import { SelectorOption } from '@libs/models';

export function enumToSelectorOptions(object: Object): SelectorOption[] {
    return Object.keys(object).map((o) => {
        return { index: o, name: object[o] };
    });
}
